import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
let _branding = null;           // { logo_light_url, logo_dark_url, updated_at }
let _inflight = null;
const _subs = new Set();

/** Fetch (public endpoint — works on the login page) and notify all <BrandLogo>s. */
export function refreshBranding() {
  _inflight = axios.get(`${BACKEND}/api/branding`)
    .then((r) => r.data)
    .catch(() => ({ logo_light_url: null, logo_dark_url: null }))
    .then((d) => { _branding = d; _subs.forEach((f) => f(d)); return d; })
    .finally(() => { _inflight = null; });
  return _inflight;
}

export function useBranding() {
  const [b, setB] = useState(_branding);
  useEffect(() => {
    _subs.add(setB);
    if (!_branding && !_inflight) refreshBranding(); else if (_branding) setB(_branding);
    return () => { _subs.delete(setB); };
  }, []);
  return b;
}

export const brandingUrl = (path) => (path ? `${BACKEND}${path}` : null);
